module.exports = __webpack_public_path__ + "img/image04.6d54c3e5.png";